/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Status_Not_FoundInputs */

const en_directory_agent_readiness_status_not_found = /** @type {(inputs: Directory_Agent_Readiness_Status_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not found in the audited source chain`)
};

const zh_directory_agent_readiness_status_not_found = /** @type {(inputs: Directory_Agent_Readiness_Status_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未在本次官方来源链中找到`)
};

/**
* | output |
* | --- |
* | "Not found in the audited source chain" |
*
* @param {Directory_Agent_Readiness_Status_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_status_not_found = /** @type {((inputs?: Directory_Agent_Readiness_Status_Not_FoundInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Status_Not_FoundInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_status_not_found(inputs)
	return zh_directory_agent_readiness_status_not_found(inputs)
});
export { directory_agent_readiness_status_not_found as "directory.agent_readiness.status.not_found" }